module.exports = __webpack_public_path__ + "static/media/at.fc3899f8.svg";